import React, { useState } from 'react';
import { View, TouchableOpacity, Text, ActivityIndicator } from 'react-native';
import InputDefault from "../../components/Form/InputDefault";
import { LinearGradient } from "expo-linear-gradient";
import AsyncStorage from '@react-native-async-storage/async-storage';

import HeaderDefault from '../../components/HeaderDefault';
import MaskedInputDefault from '../../components/Form/MaskedInputDefault';
import { toast } from '../../utils/toast';
import api from '../../services/api';

import styles from './styles';

const NewCard = ({ navigation }) => {
    const [name, setName] = useState("");
    const [numberCard, setNumberCard] = useState("");
    const [expirationDate, setExpirationDate] = useState("");
    const [ccv, setCcv] = useState("");

    const [email, setEmail] = useState("");
    const [cpfCnpj, setCpfCnpj] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [addressNumber, setAddressNumber] = useState("");
    const [phone, setPhone] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    async function saveCard() {
        setIsLoading(true);
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        if (!name) {
            toast("Preencha o nome.", "#DA1414");
            return false;
        }

        if (!numberCard) {
            toast("Preencha o número do cartão.", "#DA1414");
            return false;
        }

        if (!expirationDate) {
            toast("Preencha a validade do cartão.", "#DA1414");
            return false;
        }

        if (!ccv) {
            toast("Preencha o ccv do cartão.", "#DA1414");
            return false;
        }

        if (!email) {
            toast("Preencha email do portador.", "#DA1414");
            return false;
        }

        if (!cpfCnpj) {
            toast("Preencha o cpf/cnpj do portador.", "#DA1414");
            return false;
        }
        if (!postalCode) {
            toast("Preencha o CEP do portador.", "#DA1414");
            return false;
        }
        if (!addressNumber) {
            toast("Preencha o Número do endereço do portador.", "#DA1414");
            return false;
        }
        if (!phone) {
            toast("Preencha o telefone do portador.", "#DA1414");
            return false;
        }

        const [month, year] = expirationDate.split("/");

        const data = {
            creditCard: {
                holderName: name,
                number: numberCard,
                expiryMonth: month,
                expiryYear: year,
                ccv,
            },
            creditCardHolderInfo: {
                name,
                email,
                cpfCnpj,
                postalCode,
                addressNumber,
                phone,
            },
        };

        api
            .post("/cards", data, { headers: { Authorization: `Basic ${token}` } })
            .then(() => {
                navigation.goBack();
                setIsLoading(false);
            })
            .catch((error) => {
                console.log(error)
                toast("Houve um erro ao carregar os dados, tente novamente.", "#DA1414");
                setIsLoading(false);
            })
    }

    return (
        <>
            <HeaderDefault title={'Adicionar novo cartão'} />

            <View style={styles.container}>
                <InputDefault
                    value={name}
                    onValueChange={(value) => setName(value)}
                    placeholder={"Nome completo"}
                />

                <MaskedInputDefault
                    mask="9999 9999 9999 9999"
                    keyboardType="numeric"
                    value={numberCard}
                    onValueChange={(value) => setNumberCard(value)}
                    placeholder={"Número do cartão"}
                />

                <MaskedInputDefault
                    mask="99/9999"
                    keyboardType="numeric"
                    value={expirationDate}
                    onValueChange={(value) => setExpirationDate(value)}
                    placeholder={"Validade"}
                />

                <MaskedInputDefault
                    mask="9999"
                    keyboardType="numeric"
                    value={ccv}
                    onValueChange={(value) => setCcv(value)}
                    placeholder={"CCV"}
                />

                <Text style={styles.holderTitle}>Dados do portador</Text>

                <InputDefault
                    value={email}
                    onValueChange={(value) => setEmail(value)}
                    placeholder={"E-mail"}
                />

                <MaskedInputDefault
                    mask="999.999.999-99"
                    keyboardType="numeric"
                    value={cpfCnpj}
                    onValueChange={(value) => setCpfCnpj(value)}
                    placeholder={"Cpf/Cnpj"}
                />

                <MaskedInputDefault
                    mask="99.999-999"
                    keyboardType="numeric"
                    value={postalCode}
                    onValueChange={(value) => setPostalCode(value)}
                    placeholder={"Cep"}
                />

                <InputDefault
                    value={addressNumber}
                    keyboardType="numeric"
                    onValueChange={(value) => setAddressNumber(value)}
                    placeholder={"Número"}
                />

                <MaskedInputDefault
                    mask="(99) 99999-9999"
                    keyboardType="numeric"
                    value={phone}
                    onValueChange={(value) => setPhone(value)}
                    placeholder={"Telefone"}
                />

                <View style={styles.contentBtn}>
                    <TouchableOpacity
                        onPress={saveCard}
                        disabled={isLoading ? true : false}>

                        <LinearGradient
                            start={{ x: -1, y: 0 }}
                            end={{ x: 1, y: 0 }}
                            colors={["#16195B", "#1FBFB5"]}
                            style={styles.btn}
                        >
                            {isLoading ? (
                                <ActivityIndicator color="#1FBFB5" size="small" />
                            ) : (
                                <Text style={styles.textBtn}>ADICIONAR</Text>
                            )}
                        </LinearGradient>
                    </TouchableOpacity>
                </View></View>
        </>
    );
}

export default NewCard;